import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import CustomNavbar from './components/CustomNavbar'; 
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import PrivacyPolicy from './components/PrivacyPolicy';
import Shop from './components/Shop';
import ProductForm from './components/ProductForm';
import OrderConfirmation from './components/OrderConfirmation';

function App() {
  return (
    <Router>
      <div>
        <CustomNavbar /> 
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:productId" element={<ProductForm />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;